// src/components/Footer.jsx
import React from "react";
import { FiInstagram,  FiMail } from "react-icons/fi";
import { FaTelegram } from "react-icons/fa";
import logo from "../assets/logo.jpg"; // sizning LiveQuiz logotipingiz

export default function Footer() {
  return (
    <footer className="border-t bg-[#ffffff] pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4">

        {/* TOP SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

          {/* LEFT — LOGO + TEXT */}
          <div>
            <div className="flex items-center gap-3">
              <img src={logo} alt="LiveQuiz" className="h-10 w-auto" />
              <span className="text-2xl font-bold text-gray-900">LiveQuiz</span>
            </div>

            <p className="mt-3 text-gray-500 max-w-md">
              Har qanday kontentni sun’iy intellekt yordamida interaktiv
              onlayn testlarga aylantiring. O‘qituvchilar va o‘quvchilar uchun
              qulay, tezkor va zamonaviy platforma.
            </p>

            {/* SOCIALS */}
            <div className="flex items-center gap-4 mt-5">
              <a
                href="https://t.me/LiveQuiz_uz"
                className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
              >
                <FaTelegram className="text-lg" />
              </a>
              <a
                href="#"
                className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
              >
                <FiInstagram className="text-lg" />
              </a>
            </div>
          </div>

          {/* RIGHT — CONTACT */}
          <div className="md:text-right">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              Biz bilan bog‘laning
            </h3>

            <a
              href="mailto:hello@livequiz.uz"
              className="flex md:justify-end items-center gap-2 text-gray-700 hover:text-gray-900"
            >
              <FiMail className="text-lg" />
              hello@livequiz.uz
            </a>

            <a
              href="/contact"
              className="block mt-2 text-gray-500 hover:text-gray-700"
            >
              Aloqa formasi
            </a>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="border-t mt-10 pt-6 flex flex-col md:flex-row md:items-center md:justify-between text-gray-500 text-sm">

          {/* COPYRIGHT */}
          <p>© {new Date().getFullYear()} LiveQuiz. Barcha huquqlar himoyalangan.</p>
{/* 
          LINKS
          <div className="flex items-center gap-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-gray-700">
              Foydalanish shartlari
            </a>
            <a href="#" className="hover:text-gray-700">
              Maxfiylik siyosati
            </a>
            <span className="flex items-center gap-1">
              <span className="text-red-500 text-lg">❤️</span> 
              bilan O‘zbekistonda yaratilgan
            </span>
          </div> */}

        </div>

      </div>
    </footer>
  );
}
